module.exports = __webpack_public_path__ + "img/menu-icon.7c785098.svg";